/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setFullName} from '../api'

export const useMutationSetFullName = createReactQueryMutationHook('setFullName', setFullName)
